var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
/**
 * JSONB payload for diagnoses.object.
 *
 * Production compatibility:
 * - Legacy rows may be `{ text }` or `{ diagnose_text }` (or a raw string).
 * - New rows keep `text` always populated (API create policy + old readers)
 *   and may also include structured fields (name, code, severity, …).
 * - Backend Mutations requires every object value to be a string.
 */
var DiagnoseDetail = /** @class */ (function (_super) {
    __extends(DiagnoseDetail, _super);
    function DiagnoseDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DiagnoseDetail.prototype.getDiagnoseText = function () {
        return (this.text ||
            this.diagnose_text ||
            this.name ||
            '');
    };
    DiagnoseDetail.prototype.setDiagnoseText = function (text) {
        this.text = text;
    };
    DiagnoseDetail.prototype.getName = function () {
        return this.name || '';
    };
    DiagnoseDetail.prototype.setName = function (name) {
        this.name = name;
    };
    DiagnoseDetail.prototype.getCode = function () {
        return this.code || '';
    };
    DiagnoseDetail.prototype.setCode = function (code) {
        this.code = code;
    };
    DiagnoseDetail.prototype.getSeverity = function () {
        return this.severity || '';
    };
    DiagnoseDetail.prototype.setSeverity = function (severity) {
        this.severity = severity;
    };
    DiagnoseDetail.prototype.getConditionType = function () {
        return this.condition_type || '';
    };
    DiagnoseDetail.prototype.setConditionType = function (conditionType) {
        this.condition_type = conditionType;
    };
    DiagnoseDetail.prototype.getNotes = function () {
        return this.notes || '';
    };
    DiagnoseDetail.prototype.setNotes = function (notes) {
        this.notes = notes;
    };
    DiagnoseDetail.prototype.getOnsetDate = function () {
        return this.onset_date || '';
    };
    DiagnoseDetail.prototype.setOnsetDate = function (onsetDate) {
        this.onset_date = onsetDate;
    };
    DiagnoseDetail.prototype.getStatus = function () {
        return this.status || 'active';
    };
    DiagnoseDetail.prototype.setStatus = function (status) {
        this.status = status;
    };
    DiagnoseDetail.prototype.isResolved = function () {
        return String(this.getStatus()).toLowerCase() === 'resolved';
    };
    /**
     * Build the canonical `text` string so older clients / list UIs keep working.
     * Prefer structured name (+ optional code); fall back to free-text notes.
     */
    DiagnoseDetail.prototype.syncTextFromStructuredFields = function () {
        var name = (this.name || '').trim();
        var code = (this.code || '').trim();
        var notes = (this.notes || '').trim();
        var summary = name;
        if (name && code) {
            summary = "".concat(name, " (").concat(code, ")");
        }
        else if (!name && code) {
            summary = code;
        }
        if (summary && notes) {
            this.text = "".concat(summary, "\n").concat(notes);
        }
        else {
            this.text = summary || notes;
        }
    };
    /** Drop empty optional keys before persisting (Mutations still gets string values). */
    DiagnoseDetail.prototype.toPersistableObject = function () {
        this.syncTextFromStructuredFields();
        var payload = {
            text: this.getDiagnoseText()
        };
        var name = (this.name || '').trim();
        var code = (this.code || '').trim();
        var severity = (this.severity || '').trim();
        var conditionType = (this.condition_type || '').trim();
        var notes = (this.notes || '').trim();
        var onsetDate = (this.onset_date || '').trim();
        if (name)
            payload.name = name;
        if (code)
            payload.code = code;
        if (severity)
            payload.severity = severity;
        if (conditionType)
            payload.condition_type = conditionType;
        if (notes)
            payload.notes = notes;
        if (onsetDate)
            payload.onset_date = onsetDate;
        return payload;
    };
    return DiagnoseDetail;
}(Model));
export default DiagnoseDetail;
